﻿/*global define */

/* INFOGRAPHICS */
define(function () {
    $(function () {
        // Auto-scrolling and creation of embed links for infographic blocks
        $(".container.infographic-container").each(function () {

            var $infographicContainer = $(this),
                $infographic = $infographicContainer.find(".infographic").parent().clone(),
                $embedContainer = $infographicContainer.find(".embed-infographic textarea"),
                infographicId = $infographicContainer.attr("data-infographicid"),
                documentHash = document.location.hash.split("#")[1],
                copyButton;

            // Scroll the infographic block into view if its ID is included as the URL hash
            if (typeof documentHash !== "undefined") {
                if (documentHash.toLowerCase() === infographicId) {
                    $(window).on("load", function () {
                        setTimeout(function () {
                            var top = $infographicContainer.offset().top;

                            $("html, body").bind("scroll mousedown DOMMouseScroll mousewheel keyup", function () {
                                $("html, body").stop();
                            });

                            $("html, body").animate({
                                scrollTop: top
                            }, "slow", function () {
                                $("html, body").unbind("scroll mousedown DOMMouseScroll mousewheel keyup");
                            });

                            return false;
                        }, 10);
                    });
                }
            }

            // Create an image link for each infographic and insert it below the image
            $(this).inView(function () {
                var altText = $infographic.find("img").attr("alt"),
                    src = $infographic.find("img").attr("data-original"),
                    href = document.location.href.split("#")[0] + "#" + infographicId,
                    $embedCode = $("<div />").append(
                        $("<a />", { "title": altText, "href": href, "style": "display: block; text-align: center;" }).append(
                            $("<img />", { "src": src, "alt": altText, "title": altText, "style": "border: 0;" })
                        )
                    ),
                    $embedCodeGhost = $("<div />", { text: $embedCode.html(), "style": "padding: 5px 0;" });

                // Discover and enforce the correct textarea height
                $embedContainer.val($.trim($embedCode.html()));
                $embedContainer.after($embedCodeGhost);
                $embedContainer.height($embedCodeGhost.outerHeight());
                $embedCodeGhost.remove();

                // Add a copy button
                copyButton = Utilities.getCopyButton($embedContainer, infographicId + "-copy", "pull-right", true);
                $embedContainer.before(copyButton);

            });
        });
    });
});